import React from 'react'
import { Dispatch } from 'redux'
import { Formik } from 'formik'
import { IMediaTypeGroup } from '../../types/mediaTypeGroup'
import { push } from '../../actions/router'
import { createMediaTypeGroup } from '../../actions/mediaTypeGroup'
import { initialState } from '../../reducers/mediaTypeGroup'
import { mediaTypeGroupValidationSchema } from '../MediaTypeGroupForm/validation'
import { Spinner, NavigationGuard } from '../../components'
import MediaTypeGroupForm from '../MediaTypeGroupForm'

export interface ICreateMediaTypeGroupForm {
  mediaTypeGroup: IMediaTypeGroup
  dispatch: Dispatch
}

export const CreateMediaTypeGroupForm = ({
  mediaTypeGroup,
  dispatch,
}: ICreateMediaTypeGroupForm) =>
  !mediaTypeGroup.isLoading ? (
    <Formik
      initialValues={{ ...initialState }}
      onSubmit={(values) => {
        dispatch(createMediaTypeGroup(values))
      }}
      render={(formikProps) => (
        <>
          <MediaTypeGroupForm
            formikProps={formikProps}
            submitText="Create New Media Type Group"
            cancelAction={() => {
              formikProps.resetForm()
              dispatch(push('/settings/media-type-groups?tab=all-groups'))
            }}
          />
          <NavigationGuard isBlocking={formikProps.dirty} />
        </>
      )}
      validationSchema={mediaTypeGroupValidationSchema}
    />
  ) : (
    <Spinner />
  )
